"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.labels = void 0;
var labels = {
  he: {
    cancel: 'ביטול',
    confirm: 'אישור',
    close: 'סגירה',
    back: 'חזרה',
    save: 'שמירה',
    finished: 'סיימתי',
    save_task_btn: 'שיוך',
    update_task_btn: 'עדכון',
    main_title: 'שיוך הפעילות',
    item_select_text: 'נתחיל עם בחירת הפעילות מתוך המאגר שלך ואז נמשיך עם מסך השיוך המוכר לך.',
    select_item_btn: 'בחירת פעילות',
    select_item_popup_title: 'בחר פריט',
    show_mark_true: 'הצגת ציון ומשוב',
    show_mark_false: 'הצגת משוב בלבד',
    show_feedback_afterSubmitByAll: 'בסיום הבדיקה שלי ',
    show_feedback_immediate: 'מיד עם הגשת הפעילות',
    show_feedback_afterTeacherComment: 'תאריך מותאם אישית',
    all_students: 'כל התלמידים',
    some_students: 'חלק מהתלמידים',
    some_students_tooltip: 'הפעילות תהיה זמינה רק לתלמידים שנבחרו.<br/> הפעילות לא תופיע לתלמידים אחרים.',
    students: 'תלמידים',
    text_label_activityType: 'סוג הפעילות',
    text_label_when: 'למתי?',
    text_label_showScore: 'הצגת ציון ומשוב לתלמידים',
    text_label_whenShowScore: 'מתי להראות?',
    text_label_whenShowScore_time_title: 'אז מתי להראות את הציון לתלמידים?',
    text_label_startDate: 'תאריך התחלה',
    text_label_startDateTime: 'תאריך ושעת התחלה',
    text_label_startTime: 'שעת התחלה',
    text_label_submissionDate: 'תאריך הגשה',
    text_label_submissionDateTime: 'תאריך ושעת הגשה',
    text_label_submissionTime: 'שעת הגשה',
    text_label_schedule_time_title: 'אז למתי לשייך את המשימה?',
    text_label_schedule_time_title_exam: 'אז למתי לשייך את המבחן?',
    text_label_date: 'תאריך',
    text_label_dateTime: 'תאריך ושעה',
    text_label_associateTo: 'למי לשייך את הפעילות?',
    text_label_isAssociateTo: 'שוייכה ל:',
    text_label_time: 'שעה',
    text_label_gradeAndFeedbackDescription_grade: 'ציון + משוב המורה + חיווי לשאלות  בבדיקה אוטומטית',
    text_label_gradeAndFeedbackDescription_feedback: 'משוב המורה + חיווי לשאלות בבדיקה אוטומטית',
    text_label_taskTypeDescription_exam: 'הערכה מוגבלת בזמן לפי ימים ושעות',
    text_label_taskTypeDescription_evalWork: 'הערכה מוגבלת בזמן לפי ימים',
    text_label_taskTypeDescription_learningWork: 'למידה, תרגול, ניסוי וטעיה',
    message_can_not_edit_item: '<div>לא ניתן לערוך את הפעילות בסטודיו שלי מכיוון</div><div>שתלמידים חרוצים כבר החלו לעבוד בה</div>',
    message_groupsSelector_cant_remove: 'לא ניתן לבצע שינויים למי שכבר שויך לפעילות מכיוון שתלמידים חרוצים כבר החלו לעבוד בה.',
    message_start_date_disabled: 'לא ניתן לשנות את תאריך ההתחלה  אלא רק את תאריך הסיום מכיוון שתלמידים חרוצים כבר החלו לעבוד בפעילות',
    message_start_datetime_disabled: 'לא ניתן לשנות את תאריך ושעת ההתחלה  אלא רק את תאריך הסיום מכיוון שתלמידים חרוצים כבר החלו לעבוד בפעילות',
    message_remove_students_from_audience: 'לתשומת ליבך,<br/>אחרי שמסירים תלמידים מהמשימה אי אפשר לצפות בתשובות שלהם, גם אם הם הגישו את המשימה.<br/>אל דאגה, התשובות נשמרות ואפשר לצפות בהן שוב כשמחזירים את התלמידים למשימה.',
    title_edit_Tooltip: 'עריכת שם והנחיות',
    edit_task_title: 'עריכת שם והנחיות',
    edit_task_name_title: 'שם',
    edit_task_guideLines_title: 'תקציר והנחיות',
    open_studio_btn: 'עריכת הפעילות',
    success_title: 'מעולה הפעילות משוייכת!',
    share_Tooltip: 'שיתוף עם התלמידים להם שויכה הפעילות',
    success_goto_lms_label: 'אפשר לצפות בפעילות המשוייכת',
    success_goto_lms_btn: 'כאן',
    success_back_to_edit_btn: 'לשינוי הגדרות שיוך',
    isNotAuthorized_error_title: 'בחירה מעולה, אבל נראה שאין לך אפשרות לשייך את הפעילות כי המינוי שלך אינו כולל את הפעילות שבחרת.',
    isNotAuthorized_error_sub_title: 'זה הרגע לפנות לרכזי התקשוב בבית הספר והם כבר ידעו מה לעשות.',
    loadData_error_title: 'משהו קרה, לא הצלחנו לטעון פריטים',
    loadData_error_sub_title: 'אל דאגה, ניתן לחזור לאחור ולנסות שוב',
    cloneItem_error_title: 'משהו קרה, לא הצלחנו לפתוח פריט לעריכה',
    cloneItem_error_sub_title: 'אל דאגה, ניתן לחזור לאחור ולנסות שוב',
    saveItem_error_title: 'משהו קרה, הפעילות לא שויכה',
    saveItem_error_sub_title: 'אל דאגה, ניתן לחזור לאחור ולנסות שוב',
    share_message: 'שיתוף עם התלמידים להם שויכה הפעילות',
    share_whatsapp_startText: 'שותפה איתך פעילות ב',
    share_whatsapp_site: 'אופק',
    alert_change_exam_type_is_irreversible: 'במשימת מבחן השינוי הוא בלתי הפיך.',
    alert_can_not_re_exam: 'לא ניתן יהיה להגדיר מחדש כמבחן.',
    alert_extra_submit: 'תשובות התלמידים יישמרו, אך הם יצטרכו להגיש מחדש את המשימה.',
    alert_check_not_saved: 'אם בוצעה בדיקת מורה – היא לא תישמר.',
    alert_continue_with_change: 'האם לבצע את השינוי?',
    alert_reSubmit_task: 'התלמידים מתבקשים להגיש מחדש את המשימה, כדי שהסטטוס הסופי יעודכן',
    alert_hi: 'היי',
    alert_no_audience: 'נראה שלא מוגדרים לך תלמידים לשיוך.',
    alert_no_audience_grades: 'מומלץ לפנות למזכירות בית הספר לעדכון פרטים, או רכז תקשוב.',
    alert_no_audience_support: 'מומלץ לפנות למזכירות בית הספר לעדכון פרטים, או ללחוץ על ',
    alert_no_audience_help: 'תמיכה והדרכה',
    alert_no_audience_contact: ' וליצור קשר עם התמיכה שלנו.',
    lms_url: 'https://myOfek.{EnvDomain}/he/tasks',
    task_types_learningWork: 'פעילות ללא ציון',
    task_types_evalWork: 'פעילות עם ציון',
    task_types_exam: 'מבחן'
  },
  ar: {
    cancel: 'إلغاء',
    confirm: 'موافقة',
    close: 'إغلاق',
    back: 'عودة',
    save: 'حفظ',
    finished: 'أنهيت',
    save_task_btn: 'إضافة',
    update_task_btn: 'تحديث',
    main_title: 'إضافة الفعّاليّة',
    item_select_text: 'نبدأ باختيار الفعّاليّة من مجمّعك وبعدها نتابع مع نافذة الإضافة المعروفة لك',
    select_item_btn: 'اختيار فعّاليّة',
    select_item_popup_title: 'اختيار مادّة',
    show_mark_true: 'عرض علامة ومردود',
    show_mark_false: 'عرض مردود فقط',
    show_feedback_afterSubmitByAll: 'عند انتهاء فحصي',
    show_feedback_immediate: 'مباشرة عند تقديم الفعّاليّة',
    show_feedback_afterTeacherComment: 'تاريخ تقديم ملاءَم شخصيًّا',
    all_students: 'كلّ التلاميذ',
    some_students: 'قسم من التلاميذ',
    some_students_tooltip: 'لن تظهر الفعّاليّة لتلاميذ آخرين.  <br/>ستكون الفعّاليّة متوفّرة فقط للتلاميذ الذين تمّ اختيارهم',
    students: 'تلاميذ',
    text_label_activityType: 'نوع الفعّاليّة',
    text_label_when: 'حتى متى؟',
    text_label_showScore: 'عرض علامة ومردود للتلاميذ',
    text_label_whenShowScore: 'متى يجب؟',
    text_label_whenShowScore_time_title: 'إذًا متى يجب عرض علامة التلاميذ؟',
    text_label_startDate: 'تاريخ البداية',
    text_label_startDateTime: 'تاريخ وساعة البداية',
    text_label_startTime: 'ساعة البداية',
    text_label_submissionDate: 'تاريخ التقديم',
    text_label_submissionDateTime: 'تاريخ وساعة التقديم',
    text_label_submissionTime: 'ساعة الإنتهاء',
    text_label_schedule_time_title: 'إذًا لمتى يجب إضافة المهمّة؟',
    text_label_schedule_time_title_exam: 'إذًا لمتى يجب إضافة الامتحان؟',
    text_label_date: 'التاريخ',
    text_label_dateTime: 'التاريخ والساعة',
    text_label_associateTo: 'لمن تُضاف الفعّاليّة؟',
    text_label_isAssociateTo: 'أضيفت إلى:',
    text_label_time: 'الساعة',
    text_label_gradeAndFeedbackDescription_grade: 'علامة+ مردود المعلّم/ة + مردود في فحص تلقائيّ للأسئلة',
    text_label_gradeAndFeedbackDescription_feedback: 'مردود المعلّم/ة + مردود في فحص تلقائيّ للأسئلة',
    text_label_taskTypeDescription_exam: 'وقت تنفيذ المهامّ محدّد بالأيّام والساعات',
    text_label_taskTypeDescription_evalWork: 'وقت تنفيذ المهامّ محدّد بالأيّام',
    text_label_taskTypeDescription_learningWork: 'تعلُّم , تدرُّب , التجربة والخطأ',
    message_can_not_edit_item: '<div>لا يمكن تحرير الفعّاليّة في الأستوديو الخاصّ بي</div><div>التلاميذ مجتهدون بدأوا العمل عليها</div>',
    message_groupsSelector_cant_remove: 'لا يمكن إجراء تغييرات لمن تمّت إضافته للفعّاليّة لأنّ التلاميذ مجتهدين وبدأوا العمل عليها',
    message_start_date_disabled: 'لا يمكن تغيير تاريخ البداية، بل فقط تاريخ الإنهاء لأنّ التلاميذ مجتهدون وبدأوا العمل علي الفعّاليّة',
    message_start_datetime_disabled: 'لا يمكن تغيير تاريخ وساعة البداية، بل فقط تاريخ الإنهاء لأنّ التلاميذ مجتهدون وبدأوا العمل علي الفعّاليّة',
    message_remove_students_from_audience: 'انتبهوا!<br/>بعد حذف تلاميذ من المهمّة، لن تتمكّنوا من مشاهدة إجاباتهم، حتّى لو قدّموا المهمّة.<br/>لا تقلقوا، الإجابات محفوظة ويمكنكم مشاهدتها مرّة أخرى عند إعادة التلاميذ إلى المهمّة.',
    title_edit_Tooltip: 'تحرير الاسم وتعليمات',
    edit_task_title: 'تحرير الاسم وتعليمات',
    edit_task_name_title: 'اسم الفعّاليّة',
    edit_task_guideLines_title: 'موجز وتعليمات',
    open_studio_btn: 'تحرير الفعّاليّات',
    success_title: 'ممتاز، تمّت إضافة الفعّاليّة',
    share_Tooltip: 'مشاركة مع التلاميذ الذين أضيفت المهمّة إليهم',
    success_goto_lms_label: 'يمكن مشاهدة الفعّاليّة المضافة ',
    success_goto_lms_btn: 'هنا',
    success_back_to_edit_btn: 'لتغيير إعدادات الإضافة',
    isNotAuthorized_error_title: 'اختيار ممتاز, لكن يبدو أنّك لا تملك إمكانيّة إضافة الفعّاليّة، لأنّ اشتراكك لا يشمل الفعّاليّة التي اخترتها.',
    isNotAuthorized_error_sub_title: 'هذه هي اللحظة للتوجّه إلى مركّزي ومركّزات الحوسبة في المدرسة، وهم سيعرفون ما يجب فعله؟',
    loadData_error_title: 'حدث شيء ما، لم ننجح في تحميل الموادّ',
    loadData_error_sub_title: 'لا مشكلة، يمكن العودة إلى الوراء والمحاولة مجدّدًا',
    cloneItem_error_title: 'حدث شيء ما، لم ننجح في فتح مادة للتحرير',
    cloneItem_error_sub_title: 'لا مشكلة، يمكن العودة إلى الوراء والمحاولة مجددًا',
    saveItem_error_title: 'حدث شيء ما، الفعّاليّة لم تُضف',
    saveItem_error_sub_title: 'لا مشكلة، يمكن العودة إلى الوراء والمحاولة مجدّدًا',
    share_message: 'مشاركة مع التلاميذ الذين أضيفت إليهم المهمّة',
    share_whatsapp_startText: 'تمّت مشاركتك بمهمة من ',
    share_whatsapp_site: 'آفاق',
    alert_change_exam_type_is_irreversible: 'في مهمّة من نوع امتحان، التغيير غير قابل للاسترجاع.',
    alert_can_not_re_exam: 'لا يمكن التعريف من جديد كامتحان.',
    alert_extra_submit: 'ستُحفظ إجابات التلاميذ، لكن عليهم تقديم المهمّة من جديد.',
    alert_check_not_saved: 'إذا نفّذ المعلّم الفحص، فإنّة لن يُحفظ.',
    alert_continue_with_change: 'هل تريد إجراء التغيير؟',
    alert_reSubmit_task: 'على التلاميذ تقديم المهمّة من جديد، لتحديث الوضع النهائيّ',
    alert_hi: 'مرحبًا',
    alert_no_audience: 'يبدو أنّه لم يُحدّد لك تلاميذ لإضافة فعّاليّات.',
    alert_no_audience_grades: 'حديث التفاصيل ننصح بالتوّجه إلى سكرتاريّة المدرسة أو مركّز/ة الحوسبة،',
    alert_no_audience_support: 'ننصح بالتوجّه إلى سكرتاريّة المدرسة لتحديث التفاصيل أو النقر على ',
    alert_no_audience_help: 'دعم ومساعدة',
    alert_no_audience_contact: ' والاتّصال بالدعم الفنّيّ لمطاح.',
    lms_url: 'https://myOfek.{EnvDomain}/ar/tasks',
    task_types_learningWork: 'فعّاليّة بدون علامة',
    task_types_evalWork: 'فعّاليّة مع علامة',
    task_types_exam: 'اختبار'
  },
  en: {
    cancel: 'Cancel',
    confirm: 'Next',
    close: 'Close',
    back: 'Back',
    save: 'Save',
    finished: 'Done',
    save_task_btn: 'assign',
    update_task_btn: 'update',
    main_title: 'assign ',
    item_select_text: 'select an activity from your personal activities and than assign it to the class',
    select_item_btn: 'select',
    select_item_popup_title: 'select',
    show_mark_true: 'sure',
    show_mark_false: 'no',
    show_feedback_afterSubmitByAll: 'after my  review',
    show_feedback_immediate: 'after student submission',
    show_feedback_afterTeacherComment: 'select date',
    all_students: 'All students',
    some_students: 'Some students',
    some_students_tooltip: 'Only selected students will be exposed to the activity.<br/>The activity will not be visible to other students',
    students: 'students',
    text_label_activityType: 'type of activity',
    text_label_when: 'due',
    text_label_showScore: 'grade display',
    text_label_whenShowScore: 'Grade display time',
    text_label_whenShowScore_time_title: 'Grade display time',
    text_label_startDate: 'due date',
    text_label_startDateTime: 'due date and time',
    text_label_startTime: 'due time',
    text_label_submissionDate: 'close date',
    text_label_submissionDateTime: 'close date and time',
    text_label_submissionTime: 'close time',
    text_label_schedule_time_title: 'due date',
    text_label_schedule_time_title_exam: 'due date',
    text_label_date: 'date',
    text_label_dateTime: 'date and time',
    text_label_associateTo: 'assign to',
    text_label_isAssociateTo: 'assigned to',
    text_label_time: 'time',
    text_label_gradeAndFeedbackDescription_grade: 'Grade + teachers feedback + indication for questions in automatic test',
    text_label_gradeAndFeedbackDescription_feedback: 'The teachers feedback + an indication of the questions in an automatic test',
    text_label_taskTypeDescription_exam: 'Assessment is limited in time according to days and hours',
    text_label_taskTypeDescription_evalWork: 'Assessment is limited in time according to days',
    text_label_taskTypeDescription_learningWork: 'למידה, תרגול, ניסוי וטעיה',
    message_can_not_edit_item: '<div>you can edit the activity due to</div><div>a progress in the  assignment</div>',
    message_groupsSelector_cant_remove: 'you cant change the selected students due to a progress in the  assignment',
    message_start_date_disabled: 'you can change the due date. You can change onle the close date  due to a progress in the  assignment',
    message_start_datetime_disabled: 'you can change the due date. You can change onle the close date  due to a progress in the  assignment',
    message_remove_students_from_audience: "Please note,<br/>After removing students, you can't view their answers, even if they already submitted the task.<br/>Don't worry. The answers are saved, and you will see them again when you add the students back.",
    title_edit_Tooltip: 'edit name and instructions',
    edit_task_title: 'edit name and instructions',
    edit_task_name_title: 'title',
    edit_task_guideLines_title: 'instructions',
    open_studio_btn: 'edit activity',
    success_title: 'great! The activity is assigned',
    share_Tooltip: 'share with the assigned students',
    success_goto_lms_label: 'review the assigment ',
    success_goto_lms_btn: 'here',
    success_back_to_edit_btn: 'change assigment settings',
    isNotAuthorized_error_title: 'Great choice, but it seems that your subscription does not include this activity.',
    isNotAuthorized_error_sub_title: 'Please contact your school administrator.',
    loadData_error_title: 'something went wrong',
    loadData_error_sub_title: 'you can  click back and try again',
    cloneItem_error_title: 'something went wrong',
    cloneItem_error_sub_title: 'you can  click back and try again',
    saveItem_error_title: 'something went wrong',
    saveItem_error_sub_title: 'you can  click back and try again',
    share_message: 'share with the selected students',
    share_whatsapp_startText: 'Share a task with you in ',
    share_whatsapp_site: 'Ebag',
    alert_change_exam_type_is_irreversible: 'On the test task, the change is irreversible.',
    alert_can_not_re_exam: 'Cannot be redefined as a test.',
    alert_extra_submit: "The students' answers will be saved, but they will need to resubmit the task.",
    alert_check_not_saved: 'if the teacher has checked it, it will not be saved.',
    alert_continue_with_change: 'Make the change?',
    alert_reSubmit_task: 'The students are requested to resubmit the task, so that the final status will be updated.',
    alert_hi: 'hey',
    alert_no_audience: 'It seems you dont have students to assign to',
    alert_no_audience_grades: 'please contact schools secretary or school admin.',
    alert_no_audience_support: 'please contact schools secretary or click our ',
    alert_no_audience_help: 'Help Center',
    alert_no_audience_contact: ' in order to contact us',
    lms_url: 'https://myOfek.{EnvDomain}/en/tasks',
    task_types_learningWork: 'assignment',
    task_types_evalWork: 'assignment with score',
    task_types_exam: 'test'
  }
};
exports.labels = labels;